<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todos los Asesores Técnicos</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>
        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Nombre" min-width="140px" prop="name" sortable>
          <template #default="{ row }">
            <span>{{ row.name }}</span>

            <div v-if="row.user">
              Usuario: <span class="font-weight-bold">{{ row.user.name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Email" min-width="110px" prop="email"> </el-table-column>

        <el-table-column label="Localidad" min-width="110px" prop="address">
          <template #default="{ row }">
            <div>{{ row.city.name }}, {{ row.city.province.name }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Teléfono" min-width="110px" prop="phone"> </el-table-column>

        <el-table-column label="Última visita" min-width="110px" prop="lastVisitDate">
          <template #default="{ row }">
            <div class="text-center">
              <small v-if="row.lastVisitDate">
                {{ row.lastVisitDate | date }}
              </small>
              <small v-else> - </small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="" min-width="95px" prop="visitsCount">
          <template #default="{ row }">
            <div>
              <badge type="danger"> {{ row.visitsCount }} visitas</badge>
            </div>
            <div>
              <badge type="primary"> {{ row.distributorsCount }} distrib </badge>
            </div>
            <div>
              <badge type="success"> {{ row.distributorsVisitsCount }} visitas dist. </badge>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="140px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('show', 'sellers')"
              :to="{ name: 'SellerShow', params: { id: row.id } }"
              title="Ver"
              class="btn base-button btn-outline-info btn-sm"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <router-link
              v-if="$can('update', 'sellers')"
              :to="{ name: 'SellerEdit', params: { id: row.id } }"
              title="Editar"
              class="btn base-button btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
            <button
              v-if="$can('destroy', 'sellers')"
              title="Eliminar"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} asesores técnicos</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';

export default {
  name: 'SellersTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin, DeleteRowFromTableMixin],
  data() {
    return {
      searchKeys: ['name', 'address', 'email', 'city.name', 'city.province.name', 'phone'],
      tableData: [],
    };
  },

  created() {
    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará el asesor técnico';
    this.alertSuccessSettings.message = 'El asesor técnico ha sido eliminado';
    this.resourceName = 'sellers';
  },

  mounted() {
    this.$services
      .resource('sellers')
      .get({
        append: ['last-visit-date', 'distributors-visits-count'],
        include: ['city.province', 'visitsCount', 'distributorsCount'],
      })
      .then((res) => res.data.data)
      .then((data) => (this.tableData = data.sellers));
  },
};
</script>

<style scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: keep-all;
}
</style>
